import { useField } from 'formik';
import React from 'react';
import { Group, Item, Label, Checkmark, CheckmarkInternalCircle } from './styles';
import TextBox from '../TextBox/index';
import ErrorMessage from '../ErrorMessage';

const RadioGroup = ({
  label = null,
  options = [],
  selectedInput,
  ...props
}) => {
  const [field, metadata, helpers] = useField({ ...props });

  const handleSelect = ({ value }) => {
    helpers.setValue(value);
    if (!metadata.touched) {
      helpers.setTouched(true);
    }
  }

  return <Group>
    {options.map(option => (
      <Item key={option.value} onClick={() => handleSelect(option) }>
        <div className="mark-label">
          <Checkmark>
            {option.value === field.value && <CheckmarkInternalCircle />}
          </Checkmark>
          <Label>{option.label}</Label>
        </div>
        { option.label === 'Outros' && field.value === 3 &&
          <div className="gender-optional">
            <TextBox name="gender_detail" type="text" label="Gênero" formater="lettersAndSpace"/>
            <ErrorMessage name="gender_detail" />
          </div>
        }
      </Item>
    ))}
  </Group>
}

export default RadioGroup;
